var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCordLengthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0.00097549 0.194146) scale(0.015122)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 74,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAqCAYAAAAUJM0rAAADdUlEQVRoQ+2Z2U/6QBDHpx7ghRAlKiqQIMYr8IL+//ER4guJRohyE40E7xSVw5rvJiUo0G7p8sP+3EkML9ud8bOzc62iaZpGUkwJKBKUKSO2QILi4yRBcXKSoCQoXgKc62SMkqA4CXAukx4lQXES4FxmyaNarRZNTU3R9PQ05/b/bhkaDNjncrnGopQL1MfHB93d3dHj4yPNzMzQ5uYm+Xw+UhRlLEZZ2RSA3t/fqVwu09vbG3m9XlpfX6eFhQUr25iuNQUF5cVikf0BGDxqe3ubjo6OyO12myoY94J2u035fJ4ymQx9fn7S7OwsbWxs0P7+Pi0uLgpTbwhKh4TTajQaXaXwpkQiQcvLy8IMGXUjHN7Z2RnVarXuFvD6cDhMOzs7wmANBQV3LhQKzKV7IcGapaUlOjk5Yddv0oLDTCaTLCz0CmJVMBgUBmsgKECqVquUy+X6IDkFFOzUYe3u7tL8/LytM+0DBUilUomur6+p2WwO3NwJHqUbLsqzvoECGFw3I0gwYG5ujiKRiPDMMsqRI0YhmKuqOvRzEbC6oACpUqmw7DHMk3RLkPmgHL+TFmQ62ItfI7F7DRkoXDekf8QkM0iTBmNHPwpl3ARkQ6sxS2m32xquWzab/a8h6YBROkSjUQbMSh2oNBoNLZVK0cPDg53DctS3qP9isRitra1x262oqqqdnp6yNuCvCOJVPB5ndRavKM1mUzs/P2cx6q/I1tYWa3GsdBYsmKPyvri4oJubG9Ps4WSYyNK4bgcHB5a7im55YAUWpga/oTTQDw2lgdk7LuxdWVlhsWmU1utbwQlY6XSaNZhGdQkyx+rqKuvUJy2dTofu7+8NM7YOaW9vz1IA7/3f+lqYp6cnury8NITlpBZGBCQAG9gUAxbamNvbW8K856c4BZQOCTHJ7/fbcv6hYxbds+r1eh8sJ4AS5Uk6XcPBHSBdXV3RT1gej4eOj49HCoq2jnXAx5hHYXAHG3t7UQRuOzHppyrTUfCgaxgIBFj2EDlqHRUgQgNKG0wQIEg0yGqHh4cs4YgSU1BQBFjoB5+fn9kLTCgUIhRtMGrSgrIAdgEWXmFweLANDyAihQsUFGKq8PLywkoCxKjf9GQFWLiCr6+v7BUG8zLRwg1KtGKn7SdBcZ6YBCVBcRLgXCY9SoLiJMC5THqUBMVJgHPZF+tEQqEzzH5OAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCordLengthIcon);
export default __webpack_public_path__ + "static/media/cordLengthIcon.582d5eba950a557b92fead1b8b8492c5.svg";
export { ForwardRef as ReactComponent };